import { render, staticRenderFns } from "./MyOrganizationsView.vue?vue&type=template&id=4b096f2a&scoped=true"
import script from "./MyOrganizationsView.vue?vue&type=script&lang=js"
export * from "./MyOrganizationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b096f2a",
  null
  
)

export default component.exports